/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_TitleInputs */

const en_wc_guides_title = /** @type {(inputs: Wc_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A little guidance. Better documents.`)
};

/**
* | output |
* | --- |
* | "A little guidance. Better documents." |
*
* @param {Wc_Guides_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_title = /** @type {((inputs?: Wc_Guides_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_title(inputs)
});
export { wc_guides_title as "wc.guides.title" }